import { Button, Dropdown, Menu, Modal, Spin } from 'antd';
import { DiffTable } from './diffTable';
import { DownOutlined } from '@ant-design/icons';
import { _getMappingData, sendErrorNotification } from '../../utils/util';
import React, { useEffect, useState } from 'react';

const DiffModal = props => {
  const { toggleModal, parentState } = props;
  const [isLoading, setLoading] = useState(true);
  const [versions, setVersions] = useState([parentState.version, 'latest']);
  const [mappingsDiff, setDiff] = useState([]);
  const emptyRow = {
    path: null,
    value: null,
    driving: null,
    editable: false,
    id: null,
  };

  const handleCancel = () => {
    toggleModal(false);
  };

  const handleMenuClick = ver => {
    setVersions([parentState.version, ver.key]);
    setLoading(true);
  };

  const getMappings = async version => {
    const mapData = await _getMappingData(
      parentState.client.id,
      version,
      parentState.resourcetype,
      parentState.namespace,
      parentState.file,
    ).catch(() => {
      sendErrorNotification('There was an error getting the mapping data.');
      handleCancel();
    });
    const mappings = mapData.data.mappings.filter(
      item => item.deleted === false || item.deleted === null,
    );
    return mappings;
  };

  const getNewChanges = (current, latest, diff) => {
    // find new rows/changed drivings & values in current version
    for (const currRow of current) {
      let counter = 0;
      let foundMatch = false;

      for (const latestRow of latest) {
        counter += 1;
        let highlight = '';
        let diffPushed = {};
        let foundDiff = false;

        if (counter <= latest.length) {
          if (currRow.path === latestRow.path) {
            foundMatch = true;

            if (currRow.value !== latestRow.value) {
              highlight += 'value';
              diffPushed = {
                current: currRow,
                latest: latestRow,
                highlight,
              };
              foundDiff = true;
            }

            if (currRow.driving !== latestRow.driving) {
              highlight += 'driving';
              diffPushed = {
                current: currRow,
                latest: latestRow,
                highlight,
              };
              foundDiff = true;
            }
          }
        }

        if (foundDiff) {
          diff.push(diffPushed);
        }
      }

      if (!foundMatch) {
        diff.push({
          current: currRow,
          latest: emptyRow,
          highlight: 'added',
        });
      }
    }
  };

  const getDeletions = (current, latest, diff) => {
    // find deleted/changed paths from latest
    for (const latestRow of latest) {
      let counter = 0;
      let foundMatch = false;

      for (const currRow of current) {
        counter += 1;

        if (counter <= current.length) {
          if (currRow.path === latestRow.path) {
            foundMatch = true;
          }
        }
      }

      if (!foundMatch) {
        diff.push({
          latest: latestRow,
          current: emptyRow,
          highlight: 'deleted',
        });
      }
    }
  };

  const getDiff = async () => {
    const current = await getMappings(versions[0]);
    const latest = await getMappings(versions[1]);
    const diff = [];

    // Get changes/Additions/Deletions
    getNewChanges(current, latest, diff);
    getDeletions(current, latest, diff);

    setDiff(diff);
    setLoading(false);
  };

  useEffect(() => {
    getDiff();
  }, [versions]);

  const menus = parentState.versionOptions.map(ver => {
    return <Menu.Item key={ver}>{ver}</Menu.Item>;
  });

  const menu = () => {
    return <Menu onClick={handleMenuClick}>{menus}</Menu>;
  };

  return (
    <Modal
      title="Difference Viewer"
      style={{ top: 10 }}
      width="92%"
      height="100%"
      onClose={handleCancel}
      onOk={handleCancel}
      onCancel={handleCancel}
      open
      destroyOnClose
      data-cy="diff-view-modal"
    >
      {isLoading && <Spin />}
      {!isLoading && (
        <>
          <span>
            Comparing <code>{parentState.version}</code> to:{' '}
          </span>
          <Dropdown trigger={['click']} overlay={menu}>
            <Button>
              <code>{versions[1]}</code> <DownOutlined />
            </Button>
          </Dropdown>
          <br />
          <br />
          <DiffTable
            loading={false}
            rowClassName={() => 'editable-row'}
            dataSource={mappingsDiff}
            versions={versions}
            rowKey="id"
          />
        </>
      )}
    </Modal>
  );
};

export default DiffModal;
